import React from "react";
import * as Scrivito from "scrivito";
import { Container } from "reactstrap";
import { Dropdown, TableCustom, type TableColumn } from "components";
import { useTranslate } from "hooks";

type UploadRow = {
  id: string;
  [key: string]: unknown;
};

export const ProjectItemUploads = Scrivito.connect(() => {
  const translate = useTranslate();
  const uploadColumns: TableColumn<UploadRow>[] = [
    {
      id: "name",
      title: translate("PROJECT_ITEM_UPLOADS_NAME"),
      value: "name",
      isSortable: true,
    },
    {
      id: "date",
      title: translate("PROJECT_ITEM_UPLOADS_ADDED_ON"),
      value: "date",
    },
    {
      id: "fileType",
      title: translate("PROJECT_ITEM_UPLOADS_FILE_TYPE"),
      value: "fileType",
      colSpan: 2,
    },
    {
      id: "actionColumn",
      isWithoutHeaderTitle: true,
      align: "right",
      render(item) {
        return (
          <Dropdown
            options={[
              {
                id: "testId1",
                title: "Test title 1",
              },
              {
                id: "testId2",
                title: "Test title 2",
              },
            ]}
            btnId={item.id}
          />
        );
      },
    },
  ];

  /* TODO: forthcoming feature (hidden acc US-19953) mock data was removed */
  const uploadsData: UploadRow[] = [];

  return (
    <div className="bg-gray-100">
      <Container className="mb-8 p-4 bg-white">
        <div className="uploads">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 className="text-uppercase mb-0 text-nowrap">
              {translate("UPLOADS")}
            </h3>
            {/* TODO: forthcoming feature (hidden acc US-19953) */}
            {/* <Button data-testid="ProjectItemUploads_upload-btn" color="secondary" outline>
              {translate("PROJECT_UPLOAD_DATA")}
            </Button> */}
          </div>
          <div className="px-4">
            {uploadsData.length ? (
              <TableCustom columns={uploadColumns} data={uploadsData} />
            ) : (
              <div className="text-gray-700 fw-bold">
                {translate("PROJECT_UPLOADS_EMPTY")}
              </div>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
});
